import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

import "./../Styles/Designes.css";
import { UPLOADS } from "../../config/api";

export default function Designes({
  designs,
  downloaded,
  triggerDownload,
  handleCardClick,
  loading,
}) {
  const navigate = useNavigate();

  // const handleDownload = (design) => {
  //   const user = JSON.parse(localStorage.getItem("user"));

  //   if (!user) {
  //     navigate("/login");
  //     return;
  //   }

  //   triggerDownload(
  //     design.emb_file,
  //     design.category,
  //     design.design_code,
  //     design.id,
  //   );
  // };

  const handleDownload = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    // NOT LOGGED IN
    if (!user) {
      window.dispatchEvent(new Event("openLoginPopup"));
      return;
    }

    // LOGGED IN → DOWNLOAD
    triggerDownload(
      design.emb_file,
      design.category,
      design.design_code,
      design.id,
    );
  };
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <div className="designs-page container-fluid">
      <div className="designs-grid mt-0">
        {/* LOADING */}
        {loading ? (
          <div className="design-loading">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>

            <p>Loading Free designs...</p>
          </div>
        ) : designs.length > 0 ? (
          designs.map((design, index) => (
            <div
              className="design-card"
              key={design.id}
              data-aos="zoom-in-up"
              data-aos-delay={(index % 8) * 70}
              onClick={() => handleCardClick(design)}
            >
              <div className="image-wrapper">
                <img
                  src={`${UPLOADS.DESIGN_IMAGE}/FreeDesigns/${design.jpeg_file}`}
                  alt={design.design_code}
                />
              </div>

              <div className="card-body pb-2">
                <div className="design-specs">
                  <div className="spec-left">
                    <div>
                      <strong className="strong1">Code:</strong>{" "}
                      {design.design_code}
                    </div>

                    <div>
                      <strong className="strong1">Stitch:</strong>{" "}
                      {design.stitch}
                    </div>
                  </div>

                  <div className="spec-right text-start">
                    <div>
                      <strong className="strong1">Area:</strong> {design.area}
                    </div>

                    <div>
                      <strong className="strong1">Color:</strong> {design.color}
                    </div>
                  </div>
                </div>

                <h5 className="price-tag-row text-center mt-2 mb-0">₹ 0</h5>

                <div className="mt-3">
                  {downloaded[design.id] ? (
                    <button className="btn btn-teal1 btn-sm w-100">
                      <i className="bi bi-check-circle-fill me-1"></i>
                      Downloaded
                    </button>
                  ) : (
                    <button
                      className="btn btn-teal btn-sm w-100"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDownload(design);
                      }}
                    >
                      <i className="bi bi-download me-1"></i>
                      Download
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-5 w-100">
            <h4>No designs match your filters.</h4>
          </div>
        )}
      </div>

      <style>{`
        .design-loader-container {
          width: 100%;
          min-height: 400px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .btn-teal {
          background: #10756d;
          color: #fff;
          border: none;
          padding: 10px;
        }

        .btn-teal:hover {
          background: #10756d;
          color: #fff;
        }

        .btn-teal1 {
          background: #10756d;
          color: #fff;
          border: none;
          padding: 10px;
        }

        .btn-teal1:hover {
          background: #0f5550;
          color: #fff;
        }
      `}</style>
    </div>
  );
}
